var render, staticRenderFns
import script from "./TreatmentDwellTime.vue?vue&type=script&lang=js"
export * from "./TreatmentDwellTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef31da6",
  null
  
)

export default component.exports